# URL
url = do ->
  href = location.href.split('/')

  localRegex = /^\d+\.\d+\.\d+\.\d+/
  workRegex = /^.*\/pc\/[^\/]+\/.*$/

  for val , i in href
    if val is '' or i is href.length - 1 and val.indexOf('.')
      href.splice(i,1)

  if localRegex.test(location.hostname) is true or location.hostname.indexOf('localhost') isnt -1
    length = 2

  else if workRegex.test(location.href) is true
    length = 3

    for val , i in href
      if val is 'pc' and href[i-1] is 'work'
        length = 4

  else
    length = 1

  path = ''

  for j in [0..(length)]
    path += href[j]

    if j is 0
      path += '//'

    else
      path += '/'

  return path

options = {
  max_value: 5
  step_size: 1
  symbols: {
    utf8_star: {
      base: '\u2605　'
      hover: '\u2605　'
      selected: '\u2605　'
    }
  }
  selected_symbol_type: 'utf8_star'
  change_once : true
  ajax_method : 'POST'
  url : url + 'util/vote/'
  additional_data: {
    path : location.pathname
  }
}

$('.rating').rate(options)
